exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-partials-genericpatientinformation-style__home{padding:56px 20px;min-height:100%;width:100%}.nil-sa-partials-genericpatientinformation-style__editText{float:right;cursor:pointer;z-index:2}.nil-sa-partials-genericpatientinformation-style__editButton{margin-bottom:10px}.nil-sa-partials-genericpatientinformation-style__buttonSpinner{font-size:30px}.nil-sa-partials-genericpatientinformation-style__inputLabel{color:#5a5a5a;position:absolute!important;right:0;width:70px;padding:0 10px 0 0;text-align:right;font-size:13px;line-height:39px;z-index:2}.nil-sa-partials-genericpatientinformation-style__inputWithLabel{padding-right:60px}.nil-sa-partials-genericpatientinformation-style__customToggle{padding-right:20px;margin-top:9px}.nil-sa-partials-genericpatientinformation-style__customToggle div{margin-bottom:0}.nil-sa-partials-genericpatientinformation-style__errorMessage{color:red;padding-bottom:10px;font-size:16px}", ""]);

// exports
exports.locals = {
	"home": "nil-sa-partials-genericpatientinformation-style__home",
	"editText": "nil-sa-partials-genericpatientinformation-style__editText",
	"editButton": "nil-sa-partials-genericpatientinformation-style__editButton",
	"buttonSpinner": "nil-sa-partials-genericpatientinformation-style__buttonSpinner",
	"inputLabel": "nil-sa-partials-genericpatientinformation-style__inputLabel",
	"inputWithLabel": "nil-sa-partials-genericpatientinformation-style__inputWithLabel",
	"customToggle": "nil-sa-partials-genericpatientinformation-style__customToggle",
	"errorMessage": "nil-sa-partials-genericpatientinformation-style__errorMessage"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/partials/GenericPatientInformation/style.less
// module id = 265
// module chunks = 0